import styled from "styled-components";
import {GameNumberBadgeDefaultBox} from "./game-number-badge.default.box";

export const GameNumberBadgeMrGreenBox = styled(GameNumberBadgeDefaultBox)`
    font-size: 110px;
    font-family: "Oleo-Script-Bold", verdana, sans-serif;
    text-shadow: none;
    color: white;
    -webkit-text-fill-color: white;
    -webkit-text-stroke-width: 3px;
    -webkit-text-stroke-color: ${props => props.theme.colors.brandPrimary};
`;
